import apiRequest from './apiRequest';

const gstApi = {
    async createGstRegistration(businessInfoId, gstData, token) {
        const url = `/api/accounts/business-information/gst-registrations?businessInfoId=${businessInfoId}`;
        return apiRequest(url, 'POST', token, gstData);
    },

    async getGstRegistrations(businessInfoId, token) {
        const url = `/api/accounts/business-information/gst-registrations?businessInfoId=${businessInfoId}`;
        return apiRequest(url, 'GET', token);
    },

    async updateGstRegistration(gstRegistrationId, gstData, token) {
        const url = `/api/accounts/business-information/gst-registrations/${gstRegistrationId}`;
        return apiRequest(url, 'PUT', token, gstData);
    },

    async deleteGstRegistration(gstRegistrationId, token) {
        const url = `/api/accounts/business-information/gst-registrations/${gstRegistrationId}`;
        return apiRequest(url, 'DELETE', token);
    },
    async searchGstNo(gstin, token) {
        const url = `/api/search/gst/gstin?gstin=${gstin}&page=${0}&size=${20}`;
        return apiRequest(url, 'GET', token);
    }
};

export default gstApi;
